import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class DataMockingInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (environment.demoMode) {
      if (req.url.startsWith("{uri}/")) {
        let uri = req.url.replace("{uri}/", "");
        uri = uri.replaceAll("/", "_");

        req = req.clone({
          url: `/demo/${uri}.json`
        });
      }
    }

    return next.handle(req);
  }
}